/**
 * @description 裂变转盘奖励
 */

import { Button } from "@/components/ui/button";
import { RewardStatusEnum, RewardTypeEnum } from "@/types/reward";
import { RewardIcon } from "./reward-icon";
import { isEmpty } from "lodash-es";
import ProgressBar from "@/features/reward/components/progress-bar";
import { useRouter } from "@/i18n/navigation";
import { activityPage } from "@/const/page-url";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { ActivitySourceEnum } from "@/const/report";

interface TurntableRewardProps {
  status: RewardStatusEnum;
  cashProgress: {
    currentAmount: number;
    targetAmount: number;
  };
  currency: string;
  amount: number;
  onTurntable: () => Promise<any>;
}

export default function TurntableReward(props: TurntableRewardProps) {
  const { status, cashProgress, currency, amount, onTurntable } = props;
  const router = useRouter();
  const t = useTranslations('reward');
  const { formatCurrencyDetail } = useBalanceFormatter();
  if (![RewardStatusEnum.INVITE_NOT_PARTICIPATE, RewardStatusEnum.INVITE, RewardStatusEnum.SPIN, RewardStatusEnum.CLAIM].includes(status)) {
    return null;
  }
  const ableClaim = status === RewardStatusEnum.CLAIM;
  const showProgress = [RewardStatusEnum.INVITE, RewardStatusEnum.SPIN].includes(status);
  const progressPercent = showProgress && !isEmpty(cashProgress) ?
    (cashProgress.currentAmount / cashProgress.targetAmount) * 100 : 0;

  const actionMap = {
    [RewardStatusEnum.INVITE_NOT_PARTICIPATE]: t('getCash'),
    [RewardStatusEnum.INVITE]: t('invite'),
    [RewardStatusEnum.SPIN]: t('spin'),
    [RewardStatusEnum.CLAIM]: t('claim'),
  };

  const handleAction = async () => {
    await onTurntable?.();
    router.push(`${activityPage.lottery}?trackSource=${ActivitySourceEnum.rewardsPopup}`);
  };

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <RewardIcon type={RewardTypeEnum.TURNTABLE_REWARD} className="mr-2.5" />
      <div className="flex-1">
        <div className="flex items-center">
          <div className="text-white text-xs font-medium leading-3">{t('turntable')}</div>
        </div>
        {
          showProgress && (
            <>
              <div className="flex items-center justify-between mt-3">
                <div className="text-tertiary text-[11px] font-medium leading-3">
                  {t('getCash')} {`${formatCurrencyDetail((cashProgress?.currentAmount || 0))} / ${formatCurrencyDetail((cashProgress?.targetAmount || 0)) + ' ' + currency}`}
                </div>
              </div>
              <ProgressBar progress={progressPercent} className="mt-2 h-2" barClassName="bg-accent-blue" />
            </>
          )
        }
        {ableClaim && <div className="text-[#FFC600] text-xss mt-3 font-medium">{formatCurrencyDetail(amount)} {currency}</div>}
      </div>
      <Button
        variant={status === RewardStatusEnum.CLAIM ? 'success' : 'primary'}
        size='sm'
        className="w-[90px] ml-[10px]"
        onClick={handleAction}
      >
        {actionMap[status]}
      </Button>
    </div>
  );
}